import React, { useState, useEffect } from "react";
import { API_BASE } from "../../../apiBase";
import { bsrLabel, hasBsr } from "../../../utils";
import ModalForHide from "../../Products/Components/ModalForHide";
import NotDirectLinkPopup, {
  warningSuppliers,
} from "../../Products/Components/NotDirectLinkPopup";
import { OOSbyZIPSuppliers } from "../../Products/Components/OOSbyZIP";
import DynamicKeepaGraphPopup from "../../../components/DynamicKeepaGraphPopup";
import OOSAdvancedDataModal from "./OOSAdvancedDataModal";
import MessageBeforeLinkPopup from "../../Products/Components/MessageBeforeLinkPopup";
import { signupDiscountSuppliers } from "../../Products/Components/RegisterForDiscount";
import FavoritesIcon from "../../Products/Components/FavoritesIcon";
import { useAuth0 } from "@auth0/auth0-react";
import { checkGatedBatch } from "../../../utils";
import { getAmazonConsentUrl } from "../../../utils_amazon";

export default function OOSProductsTable(props) {
  const [bsr_state, setBsr] = useState(
    localStorage.getItem("DKGbsr") === null
      ? true
      : JSON.parse(localStorage.getItem("DKGbsr"))
  );
  const [az_state, setAz] = useState(
    localStorage.getItem("DKGaz") === null
      ? true
      : JSON.parse(localStorage.getItem("DKGaz"))
  );
  const [new_state, setNew] = useState(
    localStorage.getItem("DKGnew") === null
      ? true
      : JSON.parse(localStorage.getItem("DKGnew"))
  );
  const [bb_state, setBb] = useState(
    localStorage.getItem("DKGbb") === null
      ? true
      : JSON.parse(localStorage.getItem("DKGbb"))
  );
  const [fba_state, setFba] = useState(
    localStorage.getItem("DKGfba") === null
      ? true
      : JSON.parse(localStorage.getItem("DKGfba"))
  );
  const [range_state, setRange] = useState(
    localStorage.getItem("DKGrange") === null
      ? 90
      : localStorage.getItem("DKGrange")
  );
  const [hideModalProduct, setHideModalProduct] = useState("");
  const [linkUrl, setLinkUrl] = useState("");
  const [advancedDataProduct, setAdvancedDataProduct] = useState(null);
  const [DKGasin, setDKGAsin] = useState(null);
  const { isAuthenticated, isLoading, getAccessTokenSilently, user } = useAuth0();
  const [loginWAZ, setLoginWAZ] = useState(false);
  const [showMessageObj, setShowMessageObj] = useState(null);
  const [headerStyle, setHeaderStyle] = useState({});
  const [lastSellPrice, setLastSellPrice] = useState({});
  const [loadGated, setLatedGated] = useState(false);
  const mainProductPage = ["big5sportinggoods", "dillards", "famousfootwear", "kohls", "dickssportinggoods", "boscovs", "jcpenney", "fivebelow", "nike", "belk", "underarmour", "crocs", "champssports", "sephora", "rei", "joann"]
  const categorySalesRankCount = { 'Climate Pledge Friendly': 1500000, 'Kindle Store': 6756566, 'Video Shorts': 127580, 'Apps & Games': 936100, 'Baby Products': 4172515, 'Digital Music': 68941656, 'Alexa Skills': 112529, 'Toys & Games': 9204843, 'Patio, Lawn & Garden': 22608266, 'Books': 102997339, 'Arts, Crafts & Sewing': 16296162, 'Software': 177161, 'Sports & Outdoors': 41416624, 'Gift Cards': 28409, 'Video Games': 1204647, 'Handmade Products': 3644844, 'Clothing, Shoes & Jewelry': 275101033, 'Office Products': 12266328, 'Grocery & Gourmet Food': 3869382, 'Tools & Home Improvement': 37997159, 'Movies & TV': 7740340, 'Musical Instruments': 2893522, 'Collectibles & Fine Art': 8802597, 'Appliances': 1565048, 'Pet Supplies': 8652837, 'Cell Phones & Accessories': 26169713, 'Baby': 4172515, 'Industrial & Scientific': 20388882, 'Everything Else': 8317014, 'CDs & Vinyl': 8366789, 'Beauty & Personal Care': 14890600, 'Home & Kitchen': 161989558, 'Electronics': 25856893, 'Automotive': 46255283, 'Magazine Subscriptions': 42578, 'Health & Household': 11049107, 'Audible Books & Originals': 743380, 'Kitchen & Dining': 37818304, "Amazon Devices": 1894, "Computers & Accessories": 14064999, "Camera & Photo Products": 4021127, "Collectible Coins": 210648, "Camera & Photo": 4021127 }

  const handleScroll = () => {
    try {
      const table = document.getElementById('tableTable');
      const tableRect = table.getBoundingClientRect();

      if (tableRect.top <= 0) {
        // The header is out of view (or at the top of the viewport)
        setHeaderStyle({
          position: 'relative',
          top: -tableRect.top + "px",
          zIndex: 9,
        });
      } else {
        setHeaderStyle({});
      }
    } catch { }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const checkGated = async (asins) => {
      if (props.sellerId) {
        setLatedGated(true);
        await checkGatedBatch(props.sellerId, asins, props.refreshToken, (data) => {
          Object.entries(data).forEach(([asin, response]) => {
            props.setGatedStatus((prevGS) => ({
              ...prevGS,
              [asin]: response,
            }));
          });
        });
        props.setIsProductsLoading(false);
        setLatedGated(false);
      }
    };

    if (!isLoading && isAuthenticated && props.data && props.data.length > 0 && props.sellerId !== "none" && props.sellerId !== "") {
      const asinsToCheck = [];
      props.data.forEach(prd => {
        const asin = prd.asin.split("/")[prd.asin.split("/").length - 1];
        if (!props.gatedStatus.hasOwnProperty(asin)) {
          asinsToCheck.push(asin);
        }
      });
      if (asinsToCheck.length > 0) {
        checkGated(asinsToCheck);
      } else {
        setLatedGated(false);
      }
    }

    if (!isLoading && isAuthenticated && props.data && props.data.length > 0) {
      const lastPrices = async () => {
        await fetch(`${API_BASE}/get_oos_last_roi/`, {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json; charset=utf8",
            "Content-Type": "application/json; charset=utf8",
            Authorization: `Bearer ${await getAccessTokenSilently()}`,
          },
          body: JSON.stringify({
            data: props.data,
          })
        }).then(response => response.json())
          .then(data => {
            data.forEach(prd => {
              setLastSellPrice((prevSP) => ({
                ...prevSP,
                [prd['asin']]: prd,
              }));
            })
          })
      };
      lastPrices();
    }
    if (!isLoading && isAuthenticated && props.data && props.data.length > 0 && localStorage.getItem("azlog_pop_first") !== "1") {
      setLoginWAZ(true);
      localStorage.setItem("azlog_pop_first", "1");
    }
  }, [isLoading, isAuthenticated, props.data]);

  const openSuppLink = (product) => {
    if (!warningSuppliers.includes(product.source_name)) {
      window.open(
        product.url.replace(
          "X".repeat(product.source_name.length),
          product.source_name
        )
      );
    } else {
      setLinkUrl(
        product.url.replace(
          "X".repeat(product.source_name.length),
          product.source_name
        )
      );
    }
  };

  const getKeepaImage = async (image_asin) => {
    const accessToken = await getAccessTokenSilently();
    const params = new URLSearchParams({
      domain: 1,
      salesrank: +bsr_state ?? 1,
      amazon: +az_state ?? 1,
      new: +new_state ?? 1,
      bb: +bb_state ?? 1,
      fba: +fba_state ?? 1,
      range: range_state ?? 90
    });

    const response = await fetch(
      `${API_BASE}/get_keepa_image/${image_asin}/?${params}`,
      { mode: "cors", headers: { Authorization: `Bearer ${accessToken}` } }
    );
    const data = await response.json();
    return data.url;
  };

  return (
    <>
      <div className="table-container products-table-container">
        <table id="tableTable" className="table is-hoverable products-table">
          <thead style={headerStyle}>
            <tr>
              <th>Product</th>
              <th>Category</th>
              <th>BSR<br />Drops 30|90</th>
              <th>ASIN</th>
              <th className="tooltip">ROI(?)<span className="tooltiptext">Latest ROI - Calculated using the most recent sell price as the assumed sale price.</span></th>
              <th className="tooltip">Price(?)<span className="tooltiptext">Cost per unit from the supplier</span></th>
              <th>Dynamic Keepa Graph</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {props.data.map((product, index) => {
              if ((!props.filters.filterOutGated || (props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "green" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "orange" : "red")) : "white") !== "red") &&
                (!props.filters.showOnlyUngated || (props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "green" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "orange" : "red")) : "white") === "green")) {
                return (
                  <tr key={index}>
                    <td style={{ width: "22vw" }}>
                      <div style={{ display: "flex" }}>
                        <div className="amazonImage">
                          <p
                            onClick={() => {
                              window.open(product.asin + "?th=1&psc=1");
                            }}
                            style={{ textAlign: "center", cursor: "pointer" }}
                          >
                            Amazon
                          </p>
                          <img
                            alt="product_image"
                            className="hoverImageTable"
                            loading="lazy"
                            src={(product.az_img !== null && product.az_img !== "") ?
                              product.az_img :
                              `https://images.amazon.com/images/P/${product.asin.split("/")[product.asin.split("/").length - 1]}.jpg`}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = "/assets/noimage.png";
                            }}
                            style={{
                              borderRadius: "4.5vw",
                              border: "5px solid #E3D0DF",
                              height: "4.5vw",
                              width: "4.5vw",
                              objectFit: "scale-down",
                              position: "relative",
                              zIndex: "5"
                            }}
                            onClick={() => {
                              window.open(product.asin + "?th=1&psc=1");
                            }}
                          />
                        </div>
                        <span
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "10vw",
                            height: "10vh",
                            padding: "9px",
                            textAlign: "center",
                            margin: "auto",
                          }}
                        >
                          {product.title.split(" | At")[0].slice(0, 40) !== ""
                            ? product.title.split(" | At")[0].slice(0, 40) + "..."
                            : product.asin.split("/")[
                            product.asin.split("/").length - 1
                            ]}
                        </span>
                        <div className="sourceImage">
                          <p
                            onClick={() => {
                              let message = "";
                              if (mainProductPage.includes(product.source_name)) {
                                message +=
                                  "You will see the main product page.\nYou will need to set the correct variation yourself.\n..." + product.title.split(" | At")[0].slice((product.title.split(" | At")[0].length / 2).toFixed(0)) + "<br/>";
                              }
                              if (
                                signupDiscountSuppliers.includes(
                                  product.source_name
                                )
                              ) {
                                message +=
                                  "To receive the lowest price, this supplier requires you to sign up to their website.";
                              }
                              if (
                                OOSbyZIPSuppliers.includes(
                                  product.source_name
                                )
                              ) {
                                message +=
                                  "\nIf the product is out of stock - Change the ZIP CODE!\n";
                              }
                              if (message !== "" && (localStorage.getItem("showSuppMesssage" + product.source_name) === 'true' || localStorage.getItem("showSuppMesssage" + product.source_name) === null)) {
                                setShowMessageObj({
                                  message: message,
                                  messageAction: openSuppLink,
                                  messageActionArg: product,
                                  source: product.source_name
                                });
                              } else {
                                openSuppLink(product);
                              }
                            }}
                            style={{
                              textAlign: "center",
                              maxWidth: "4.5vw",
                              cursor: "pointer",
                            }}
                          >
                            {product.source_name}
                          </p>
                          <img
                            alt="product_image"
                            className="hoverImageTable"
                            loading="lazy"
                            src={product.img}
                            title={product.source_name === "dickssportinggoods" ? "The variations may vary" : ""}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = "/assets/noimage.png";
                            }}
                            style={{
                              borderRadius: "4.5vw",
                              border: "5px solid #E3D0DF",
                              height: "4.5vw",
                              width: "4.5vw",
                              objectFit: "scale-down",
                              position: "relative",
                              zIndex: "5"
                            }}
                            onClick={() => {
                              let message = "";
                              if (mainProductPage.includes(product.source_name)) {
                                message +=
                                  "You will see the main product page.\nYou will need to set the correct variation yourself.\n..." + product.title.split(" | At")[0].slice((product.title.split(" | At")[0].length / 2).toFixed(0)) + "<br/>";
                              }
                              if (
                                signupDiscountSuppliers.includes(
                                  product.source_name
                                )
                              ) {
                                message +=
                                  "To receive the lowest price, this supplier requires you to sign up to their website.";
                              }
                              if (
                                OOSbyZIPSuppliers.includes(
                                  product.source_name
                                )
                              ) {
                                message +=
                                  "\nIf the product is out of stock - Change the ZIP CODE!\n";
                              }
                              if (message !== "" && (localStorage.getItem("showSuppMesssage" + product.source_name) === 'true' || localStorage.getItem("showSuppMesssage" + product.source_name) === null)) {
                                setShowMessageObj({
                                  message: message,
                                  messageAction: openSuppLink,
                                  messageActionArg: product,
                                  source: product.source_name
                                });
                              } else {
                                openSuppLink(product);
                              }
                            }}
                          />
                          {(product.source_name === "boscovs" || product.source_name === "dickssportinggoods" || product.source_name === "rei" || product.source_name === "b2bsportswear" || product.source_name === "joann") &&
                            <div className="warningSign">
                              <i class="fa fa-info-circle" aria-hidden="true"></i>
                              <span className="warText"> See the correct variation on {product.source_name}'s website.</span>
                            </div>}
                        </div>
                        {product.title.includes("Last Update") && (
                          <span
                            style={{
                              fontSize: "0.7vw",
                              position: "absolute",
                              marginTop: "5.75%",
                              marginLeft: "-1%",
                              opacity: "0.7",
                              height: "0px",
                            }}
                            id="foundOnText"
                          >
                            Found on{" "}
                            {new Date(product.title.split("Last Update: ")[1])
                              .toLocaleString()
                              .includes("Invalid")
                              ? product.title.split("Last Update: ")[1]
                              : new Date(
                                product.title.split("Last Update: ")[1]
                              ).toLocaleString()}
                          </span>
                        )}
                      </div>
                    </td>
                    <td style={{ width: "8vw", maxWidth: "8vw", color: !categorySalesRankCount[product.category] && "darkred" }}>
                      {product.category === null ? "N/A" : product.category}
                    </td>
                    <td id="bsrTt" style={{ minWidth: "5.6vw", color: !categorySalesRankCount[product.category] && "darkred" }}>
                      {bsrLabel(product.sales_rank)}{hasBsr(product.sales_rank) && categorySalesRankCount[product.category] && <><br /><span style={{ fontSize: "83%" }}>Top {((product.sales_rank / categorySalesRankCount[product.category]) * 100) < 0.01 ? "<0.01" : ((product.sales_rank / categorySalesRankCount[product.category]) * 100).toFixed(((product.sales_rank / categorySalesRankCount[product.category]) * 100) < 0.1 ? 2 : 1)}%</span></>}
                      <br />{lastSellPrice.hasOwnProperty(product.asin) && `${Math.round(lastSellPrice[product.asin].sales_rank_drops_90 / 3)} | ${lastSellPrice[product.asin].sales_rank_drops_90}`}
                    </td>
                    <td>
                      <a
                        href={product.asin}
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: "underline", color: "#8B3C7E" }}
                      >
                        {
                          product.asin.split("/")[
                          product.asin.split("/").length - 1
                          ]
                        }
                      </a>
                    </td>
                    <td style={{ width: "2.5vw", maxWidth: "2.5vw", backgroundColor: lastSellPrice.hasOwnProperty(product.asin) && lastSellPrice[product.asin].last_roi > 0 ? "lightgreen" : "rgba(255,0,0,0)" }}>{lastSellPrice.hasOwnProperty(product.asin) && lastSellPrice[product.asin].last_roi !== -1 ? `${(lastSellPrice[product.asin].last_roi * 100).toFixed(1)}%` : (Object.keys(lastSellPrice).length > 0 ? "N/A" : <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>)}</td>
                    <td style={{ width: "6vw", maxWidth: "6vw" }} id="buyPriceTt">
                      ${product.price.toFixed(2)}
                    </td>
                    <td
                      className="no-bg"
                      id="dyamicKeepaTt"
                      style={{
                        width: "18vw",
                        maxWidth: "18vw",
                        zIndex: "9999 !important",
                        padding: "0"
                      }}
                    >
                      <img
                        loading="lazy"
                        onClick={() =>
                          setDKGAsin(
                            product.asin.split("/")[
                            product.asin.split("/").length - 1
                            ]
                          )
                        }
                        onMouseEnter={async (e) => {
                          if (e.target.alt !== "keepahistloaded") {
                            e.target.src = "data:image/svg+xml;base64," + btoa('<svg width="100" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="100%" height="100%" fill="#f5f5f5"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" font-size="12" fill="#666">Loading...</text></svg>');
                            const new_url = await getKeepaImage(product.asin.split("/")[product.asin.split("/").length - 1])
                            e.target.src = new_url
                            e.target.alt = "keepahistloaded"
                          }
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            'data:image/svg+xml;base64,' +
                            btoa('<svg width="100" height="50" xmlns="http://www.w3.org/2000/svg"><rect width="100%" height="100%" fill="#f5f5f5"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" font-size="12" fill="#666">Hover to reveal...</text></svg>');
                        }}
                        src={DKGasin === null ? `https://corsproxy.io/?https://graph.keepa.com/?asin=${product.asin.split("/")[
                          product.asin.split("/").length - 1
                        ]
                          }&domain=com&salesrank=${+bsr_state}&amazon=${+az_state}&new=${+new_state}&bb=${+bb_state}&fba=${+fba_state}&range=${range_state}` : '/assets/dkg_loading.png'}
                        alt="keepahist"
                        style={{ position: "relative", border: "1px solid gray" }}
                        className="keepagraphoos"
                      />
                    </td>
                    <td className="no-bg" style={{ width: "15vw" }}>
                      <div
                        className="columns is-centered"
                        style={{ display: "flex" }}
                      >
                        <button
                          className="button is-rounded"
                          id="hideTt"
                          style={{
                            backgroundColor: "#8B3C7E",
                            color: "white",
                            fontWeight: "700",
                            marginLeft: "3px",
                            fontSize: ".64vw",
                          }}
                          onClick={() => {
                            setHideModalProduct(product);
                          }}
                        >
                          HIDE FROM OTHERS
                        </button>
                        <FavoritesIcon oos={true} url={product.url} favorite={product.favorite} />
                      </div>
                      <div
                        className="columns is-centered"
                        style={{ display: "flex", marginTop: "1px" }}
                      >
                        <img
                          className="graphicon advDataTt"
                          alt="graph"
                          onClick={() => setAdvancedDataProduct(product)}
                          src={"/assets/graph.png"}
                          style={{
                            width: "2.25vw",
                            marginTop: "1px",
                            marginLeft: "3px",
                            height: "2.25vw",
                            borderRadius: "20px",
                            border: "3px solid purple",
                            boxShadow: "0px 0px 5px 1px purple",
                            padding: "3px",
                          }}
                        />
                        <i
                          className={`fa ${(loadGated && !props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1])) ? "fa-spinner fa-spin" : (props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "fa-unlock" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "fa-unlock-alt" : "fa-lock")) : "fa-unlock-alt")} graphicon gatedTt`}
                          style={{
                            width: "2.25vw",
                            marginTop: "1px",
                            marginLeft: "3px",
                            height: "2.25vw",
                            borderRadius: "20px",
                            border: "2px solid gray",
                            padding: (loadGated && !props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1])) ? "0.15vw" : "0.3vw 0.2vw",
                            cursor: "pointer",
                            fontSize: "1.6vw",
                            color: props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? "white" : "rgb(195, 65, 2)",
                            backgroundColor: props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "green" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "orange" : "red")) : "white"
                          }}
                          id="gatedTt"
                          onClick={() => {
                            if (props.sellerId === "none" || props.sellerId === "") {
                              setLoginWAZ(true);
                            }
                            window
                              .open(
                                "https://sellercentral.amazon.com/hz/approvalrequest/restrictions/approve?asin=" +
                                product.asin.split("/")[
                                product.asin.split("/").length - 1
                                ],
                                "_blank"
                              )
                              .focus()
                          }}
                          aria-hidden="true"
                        ></i>
                        <img
                          className="graphicon keepaTt"
                          alt="keepa"
                          onClick={() =>
                            window.open(
                              `https://keepa.com/#!product/1-${product.asin.split("/")[
                              product.asin.split("/").length - 1
                              ]
                              }}`,
                              "_blank"
                            )
                          }
                          src={"/assets/keepa.png"}
                          style={{
                            width: "2.25vw",
                            marginTop: "1px",
                            marginLeft: "3px",
                            height: "2.25vw",
                            borderRadius: "20px",
                            border: "2px solid gray",
                            padding: "3px",
                          }}
                        />
                        <i
                          className="fa fa-exclamation-triangle graphicon tooltip"
                          style={{
                            width: "2.25vw",
                            marginTop: "1px",
                            marginLeft: "3px",
                            height: "2.25vw",
                            borderRadius: "20px",
                            border: "2px solid gray",
                            padding: "0.4vw 0.2vw",
                            cursor: "pointer",
                            fontSize: "1.3vw",
                            color: "darkred",
                          }}
                          id="reportTt"
                          onClick={() => {
                            if (
                              window.confirm(
                                "Report a mismatch?\nNote: Users who find 50 mismatches will receive a free subscription!\n\nThe report will be sent to our team for verification. After confirming the mismatch, it will be counted."
                              )
                            ) {
                              props.reportMismatch(
                                product.asin.split("/")[
                                product.asin.split("/").length - 1
                                ]
                              );
                              localStorage.setItem(product.asin.split("/")[product.asin.split("/").length - 1] + "NIU", Date.now() + 30 * 24 * 60 * 60 * 1000);
                            }
                          }}
                          aria-hidden="true"
                        >
                          {" "}
                          <span
                            class="tooltiptext"
                            style={{
                              zIndex: "2000",
                              fontFamily: "sans-serif",
                              marginTop: "-25%",
                              fontSize: ".75vw",
                            }}
                          >
                            Report a mismatch
                          </span>
                        </i>
                      </div>
                    </td>
                  </tr>
                );
              }
            })}
            {(props.filters.filterOutGated || props.filters.showOnlyUngated) && (!props.data.map((d) => d.asin.split("/")[d.asin.split("/").length - 1]).every((a) => props.gatedStatus.hasOwnProperty(a)) && <tr><td colSpan={12} style={{ border: "none" }}>Checking your eligibility to sell (checking if you are gated)...{(props.sellerId === "none" || props.sellerId === "") && <button style={{ marginLeft: "15px", backgroundColor: "orange", border: "2px solid gray", borderRadius: "30px", cursor: "pointer", boxShadow: "0px 0px 5px 0px black" }} onClick={() => { localStorage.removeItem("no_azlog_popup"); setLoginWAZ(true) }}>Please click here to link your Amazon account.</button>}<progress className="progress" style={{ width: "100%", margin: "auto" }} /></td></tr>)}
            {(props.filters.filterOutGated || props.filters.showOnlyUngated) && props.data.length > 0 && (props.data.map((d) => d.asin.split("/")[d.asin.split("/").length - 1]).every((a) => props.gatedStatus.hasOwnProperty(a)) && props.data.filter((product) => {
              if ((!props.filters.filterOutGated || (props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "green" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "orange" : "red")) : "white") !== "red") &&
                (!props.filters.showOnlyUngated || (props.gatedStatus.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "green" : (props.gatedStatus[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "orange" : "red")) : "white") === "green")) {
                return true
              }
            }).length === 0 && <tr><td colSpan={12} style={{ border: "none" }}>No products for which you are <strong style={{ color: "purple" }}>ungated</strong> were found on this page. Please go to the <strong style={{ color: "purple" }}>next page</strong> or set the 'Gated' filter to 'Filter out Gated ASINs' only.</td></tr>)}
          </tbody>
        </table>

        <div
          style={{
            width: "70vw",
            margin: "auto",
            height: "10vh",
            textAlign: "center",
          }}
        >
          <button
            className="button"
            style={{
              float: "left",
              width: "10vw",
              fontSize: "1.1vw",
              backgroundColor: "#8B3C7E",
              color: "white",
            }}
            onClick={() => {
              props.setPage((page) => (page > 1 ? page - 1 : 1));
              window.scrollTo(0, 0);
            }}
          >
            Previous Page
          </button>
          <span>Page {props.page}</span>
          <button
            className="button"
            style={{
              float: "right",
              width: "10vw",
              fontSize: "1.1vw",
              backgroundColor: "#8B3C7E",
              color: "white",
            }}
            onClick={() => {
              if (props.page > 99) {
                alert("You can view up to 100 pages. Please try a new search :)")
              } else {
                props.setPage((page) => page + 1);
                window.scrollTo(0, 0);
              }
            }}
          >
            Next page
          </button>
        </div>
      </div>
      {hideModalProduct !== "" && (
        <ModalForHide
          isMobile={props.isMobile}
          setHideModalProduct={setHideModalProduct}
          hideModalProduct={hideModalProduct}
          hideCredits={props.hideCredits}
        />
      )}
      {linkUrl !== "" && (
        <NotDirectLinkPopup
          isMobile={props.isMobile}
          setLinkUrl={setLinkUrl}
          linkUrl={linkUrl}
        />
      )}
      {DKGasin !== null && (
        <DynamicKeepaGraphPopup
          asin={DKGasin}
          setDKGAsin={setDKGAsin}
          bsr_state={bsr_state}
          setBsr={setBsr}
          bb_state={bb_state}
          setBb={setBb}
          az_state={az_state}
          setAz={setAz}
          fba_state={fba_state}
          setFba={setFba}
          new_state={new_state}
          setNew={setNew}
          range_state={range_state}
          setRange={setRange} />
      )}
      {loginWAZ && localStorage.getItem("no_azlog_popup") !== "1" && (
        <div
          id="modal-js-example"
          className={
            "modal" + (loginWAZ !== null ? " is-active" : "")
          }
        >
          <div className="modal-background"></div>
          <div
            className="modal-content"
            style={{ width: props.isMobile ? "90vw" : "38vw" }}
          >
            <div className="box" style={{ textAlign: "center", fontWeight: "600" }}>
              <p style={{ fontSize: props.isMobile ? "2.5vh" : "1.1vw" }}>
                Log in to your Amazon account to automate the eligibility check!
              </p>
              <br />
              <i
                className="fa fa-unlock graphicon tooltip"
                style={{
                  width: "2.25vw",
                  height: "2.25vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.3vw 0.2vw",
                  fontSize: "1.6vw",
                  color: "white",
                  backgroundColor: "green"
                }} />&emsp;GREEN - You CAN sell this item!
              <br /><br />
              <i
                className="fa fa-lock graphicon tooltip"
                style={{
                  width: "2.25vw",
                  height: "2.25vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.3vw 0.2vw",
                  fontSize: "1.6vw",
                  color: "white",
                  backgroundColor: "red"
                }} />&emsp;RED - You CANNOT sell this item!
              <br /><br />
              <i
                className="fa fa-unlock-alt graphicon tooltip"
                style={{
                  width: "2.25vw",
                  height: "2.25vw",
                  borderRadius: "20px",
                  border: "2px solid gray",
                  padding: "0.3vw 0.2vw",
                  fontSize: "1.6vw",
                  color: "white",
                  backgroundColor: "orange"
                }} />&emsp;ORANGE - You need to APPLY to sell this item!
              <br /><br /><br />
              <i class="fa fa-arrow-right" aria-hidden="true" style={{ fontSize: "25px", marginRight: "10px" }}></i>
              {user && user.email && <img src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_156x32.png" onClick={() => window.open(getAmazonConsentUrl(user.email))} style={{ resizeMode: 'center', cursor: "pointer", boxShadow: "0px 0px 5px 0px gray", borderRadius: "5px", marginBottom: "-8px" }} />}
              <i class="fa fa-arrow-left" aria-hidden="true" style={{ fontSize: "25px", marginLeft: "10px" }}></i>
              <br /><br /><br />
              <div className="columns is-mobile is-centered" style={{ marginBottom: "1%", marginTop: '1%' }}>
                <button
                  className="button is-rounded is-danger is-outlined"
                  style={{ fontSize: props.isMobile ? "1.9vh" : ".95vw" }}
                  onClick={() => {
                    setLoginWAZ(false);
                    localStorage.setItem("no_azlog_popup", "1")
                  }}
                >
                  Do not show this message again
                </button>&emsp;
                <button
                  className="button is-rounded is-danger"
                  style={{ fontSize: props.isMobile ? "1.9vh" : ".95vw" }}
                  onClick={() => {
                    setLoginWAZ(false);
                  }}
                >
                  Close for Now
                </button>
              </div>
            </div>
          </div>
        </div>)}
      {advancedDataProduct !== null &&
        <OOSAdvancedDataModal
          advancedDataProduct={advancedDataProduct}
          setAdvancedDataProduct={setAdvancedDataProduct}
          data={lastSellPrice.hasOwnProperty(advancedDataProduct.asin) ? lastSellPrice[advancedDataProduct.asin] : null}
          isMobile={props.isMobile}
        />
      }
      {showMessageObj !== null && (
        <MessageBeforeLinkPopup
          showMessageObj={showMessageObj}
          setShowMessageObj={setShowMessageObj}
        />
      )}
    </>
  );
}
